import { createClient } from "@supabase/supabase-js";
import { isSupabaseConfigured, runtimeConfig } from "@/lib/runtimeConfig";

const shouldUseSupabase = isSupabaseConfigured && import.meta.env.MODE !== "test";

export const supabase = shouldUseSupabase
  ? createClient(runtimeConfig.supabaseUrl, runtimeConfig.supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
  : null;
